import { useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Form, Row, Col, Label, Input, Button, FormFeedback, Spinner } from 'reactstrap'; // Assuming you're using Reactstrap
import { ChangeUserPassword } from '../../utility/api/services/UserPortal/UserSlice';
import { myToast } from '../../snippets/snippets';
import UserPortalService from '../../utility/api/services/UserPortal/UserService';
import InputPasswordToggle from "@components/input-password-toggle"

const UpdatePassword = (props) => {
    console.log('PROPS::', props)

    const dispatch = useDispatch();

const PasswordSchema = yup.object().shape({
  oldPassword: yup.string().required("Please enter your old password"),
  newPassword: yup.string().required('Please enter a new password'),
  confirmPassword: yup.string()
    .oneOf([yup.ref('newPassword'), null], 'Passwords must match')
    .required('Please confirm your new password'),
});

const {
  control,
  handleSubmit,
  formState: { errors }
} = useForm({
  mode: "onChange",
  resolver: yupResolver(PasswordSchema),
  defaultValues: { oldPassword: '', newPassword: '', confirmPassword: '' }
});

const handleTimeoutAlert = (obj) => {

  console.log('obj==obj', obj)

    const myPromise = new Promise(async(resolve, reject) => {
      if(props.currentModalName == "User Password"){
        
          UserPortalService.UpdateUserPassword(obj)
           .then((response) => {
             console.log('RESULT', response)
               const result = response
               
               
              if(result.statusCode === 400){
               return  reject(result)
              }else{
                resolve(result)
                props.setInputModal(false)
              }
           })
      //      .catch((err) => {
      //       console.log('err',err)
      //      reject(err)
      //  })
      }
    })
    console.log('myToastUpdate', myPromise)
    return myToast(myPromise)


}

const onSubmit = (data) => {
  console.log(data);
  const obj = {
    oldPassword:data.oldPassword,
    newPassword:data.newPassword
  }
  if(obj.oldPassword != '' && obj.newPassword != ''){
    console.log('HEHE')

    handleTimeoutAlert(obj)
  }

};


  return (
    <>
        <div>
            
<Form className='auth-password-form mt-2' onSubmit={handleSubmit(onSubmit)}>
  <Row>
    <Col xl='12' lg='12' md='12' sm='12' xs='12'>
      <div className="mb-1">
        <Label className="form-label" for="oldPassword">Old Password</Label>
        <Controller
          id='oldPassword'
          name='oldPassword'
          control={control}
          render={({ field }) => (
            <InputPasswordToggle className='input-group-merge' invalid={loginErrors.oldPassword && true} {...field} />
          )}
        />
        {errors.oldPassword && <FormFeedback>{errors.oldPassword.message}</FormFeedback>}
      </div>
    </Col>

    <Col xl='12' lg='12' md='12' sm='12' xs='12'>
      <div className="mb-1">
        <Label className="form-label" for="newPassword">New Password</Label>
        <Controller
          id='newPassword'
          name='newPassword'
          control={control}
          render={({ field }) => (
            <InputPasswordToggle className='input-group-merge' invalid={loginErrors.newPassword && true} {...field} />
          )}
        />
        {errors.newPassword && <FormFeedback>{errors.newPassword.message}</FormFeedback>}
      </div>
    </Col>

    <Col xl='12' lg='12' md='12' sm='12' xs='12'>
      <div className="mb-1">
        <Label className="form-label" for="confirmPassword">Confirm New Password</Label>
        <Controller
          id='confirmPassword'
          name='confirmPassword'
          control={control}
          render={({ field }) => (
            <InputPasswordToggle className='input-group-merge' invalid={loginErrors.confirmPassword && true} {...field} />
          )}
        />
        {errors.confirmPassword && <FormFeedback>{errors.confirmPassword.message}</FormFeedback>}
      </div>
    </Col>

    <Col xl='12' lg='12' md='12' sm='12' xs='12'>
      <div style={{ display: 'flex', width: '100%', justifyContent: 'end' }}>
        <button  type='submit' className='btn mt-2' style={{ backgroundColor: '#FBBD34', color: 'white' }}>
          {/* <Spinner size="sm" />  */}
          Change Password
        </button>
      </div>
    </Col>
  </Row>
</Form>
        </div>
    </>
  )
}

export default UpdatePassword
